import { idStatusTypes, termsStatusTypes } from '../constants/statusConstants';
import { isBrownoutOn } from '../utils/brownoutUtil';

import { fetchIdVerificationStatusApi, getTermSetApi, processDataWrap } from '../utils/api';
import {
  FETCH_ID_VERIFICATION_STATUS_SUCCESS,
  FETCH_TERMS_STATUS_SUCCESS,
  UPDATE_IS_ID_VERIFYING,
} from '../constants/actionTypes';
import { REQUESTING_CLIENT } from '../constants/commonParameters';
const { CURRENTLY_IDENTIFIED } = idStatusTypes;
import { logError } from '@zg-rentals/log-error';

export function fetchIdVerificationStatusSuccess(payload) {
  return { type: FETCH_ID_VERIFICATION_STATUS_SUCCESS, payload };
}

export function fetchTermsStatusSuccess(payload) {
  return { type: FETCH_TERMS_STATUS_SUCCESS, payload };
}

const fetchIdVerificationStatus = () => (dispatch) => {
  return dispatch(fetchIdVerificationStatusApi({ requestingClient: REQUESTING_CLIENT })).then(
    (response = {}) => {
      if (response && response.data) {
        const processedData = processDataWrap(response.data);
        const statusText = processedData.identificationStatusType;
        const isIdVerified = statusText === CURRENTLY_IDENTIFIED;

        dispatch(fetchIdVerificationStatusSuccess({ isIdVerified }));
        return isIdVerified;
      } else {
        logError({ context: 'Error fetching id verification status', error: response.message });

        dispatch(fetchIdVerificationStatusSuccess({ isIdVerified: false }));
        return false;
      }
    },
    (serverError = {}) => {
      logError({ context: 'Error fetching id verification status', error: serverError.message });
      if (isBrownoutOn(serverError)) {
        return;
      }

      dispatch(fetchIdVerificationStatusSuccess({ isIdVerified: false }));
      return false;
    },
  );
};

const fetchTermsStatus = () => (dispatch, getState) => {
  const {
    user: { userToken },
  } = getState();

  return dispatch(
    getTermSetApi({
      userId: userToken,
      zgAuthZone: 'zillow',
      termSetId: 'landlordScreening',
    }),
  ).then(
    (termSetResponse = {}) => {
      if (termSetResponse && termSetResponse.data) {
        const { data: { attributes: { status: termsStatus } = {} } = {} } = termSetResponse.data;

        dispatch(fetchTermsStatusSuccess({ termsStatus }));
        return termsStatus;
      } else {
        logError({ context: 'Error getting term set', error: termSetResponse });

        dispatch(fetchTermsStatusSuccess({ termsStatus: termsStatusTypes.TAC_NEVER_ACCEPTED }));
        return termsStatusTypes.TAC_NEVER_ACCEPTED;
      }
    },
    (serverError = {}) => {
      logError({ context: 'Error getting term set status', error: serverError.message });
      if (isBrownoutOn(serverError)) {
        return;
      }

      dispatch(fetchTermsStatusSuccess({ termsStatus: termsStatusTypes.TAC_NEVER_ACCEPTED }));
      return termsStatusTypes.TAC_NEVER_ACCEPTED;
    },
  );
};

export function updateIdVerifying(payload) {
  return { type: UPDATE_IS_ID_VERIFYING, payload };
}

export { fetchIdVerificationStatus, fetchTermsStatus };
